import { useMemo } from 'react'

import { useCardViewContext } from 'features/views/ListView/CardView/useCardViewContext'

export function useCardViewGridState() {
    const { cardSize } = useCardViewContext()

    return useMemo(() => ({ cardSize }), [cardSize])
}
